import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { PronosticoMeteorologicoState } from './types'

export const state: PronosticoMeteorologicoState = {
  inicio: new Date().toISOString(),
  imagenes: {
    VectoresViento: [],
    Precipitacion: [],
    MagnitudViento: [],
    Temperatura: []
  },
  pasos: 0,
  ruta: '',
  fecha_inicio_nieve: null,
  centro: [],
  latlong: [[]],
  delta: 0,
  etiquetas: {
    Temperatura: 'Temperatura',
    MagnitudViento: 'Magnitud del Viento',
    Precipitacion: 'Precipitaci&oacute;n'
  },
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoMeteorologico: Module<PronosticoMeteorologicoState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
